<child-header *ngIf="data.item.lr_stock_code != ''" title="SEND ENQUIRY - {{data.item.lr_secondary_cat}} > {{data.item.lr_stock_code}}" (closeEvent)="onNoClick()"></child-header>
<child-header *ngIf="data.item.lr_stock_code == ''" title="SEND ENQUIRY - {{data.item.lr_stk_brand}}" (closeEvent)="onNoClick()" ></child-header>
<!-- <button class="close-button" (click)="onNoClick()">
  <span aria-hidden="true">&times;</span>
</button>
<h1 *ngIf="data.item.lr_stock_code != ''" mat-dialog-title class="pop-up-title">SEND ENQUIRY - {{data.item.lr_secondary_cat}} > {{data.item.lr_stock_code}}</h1>
<h1 *ngIf="data.item.lr_stock_code == ''" mat-dialog-title class="pop-up-title">SEND ENQUIRY - {{data.item.lr_stk_brand}}</h1> -->
<div class="mat-dialog-body">
  <div mat-dialog-content>
    <p *ngIf="data.item.lr_stock_code != ''">
      Please enter your enquiry
    </p>
    <p *ngIf="data.item.lr_stock_code == ''">
      Products and services from this vendor are not able to be purchased through our website. Please enter your enquiry below and our team will respond to you shortly.
    </p>
    <textarea class="note-wrapper" cols="20" id="comments" name="comments" rows="8" [(ngModel)]="comments"
      maxlength="600"
      placeholder="This product has additional requirements that need to be fulfilled prior to ordering.  Please add your enquiry details below and a customer service agent will be in contact to discuss your needs. (600 characters)"
    ></textarea>

    <mat-form-field style="margin-top: 15px;">
      <input matInput type="text" class="email" [(ngModel)]="email" placeholder="Contact email"/>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-large continue"
      (click)="sendEnquiry()">Send</button>
  </div>
</div>